import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiCallService } from '../../../Services/api-call-service.service';
import { CommonModule, isPlatformBrowser, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ErrorhandlingService } from '../../../Services/error-handling.service';
import { Router } from '@angular/router';
import { LoaderService } from '../../../Services/loader-service.service';
import { ModalService } from '../../../Services/modal.service';
declare let fbq: Function;

@Component({
  selector: 'app-sign-up-pop-up',
  standalone: true,
  imports: [CommonModule, NgIf, FormsModule],
  templateUrl: './sign-up-pop-up.component.html',
  styleUrls: ['./sign-up-pop-up.component.scss'],
})
export class SignUpPopUpComponent implements OnInit {
  timer: number = 60; // 1-minute timer
  email: string | null = null; // Email passed from the parent component
  verificationCode: string[] = ['', '', '', '', '', ''];

  constructor(
    private dialogRef: MatDialogRef<SignUpPopUpComponent>,
    private apiCallService: ApiCallService,
    private toaster: ToastrService,
    private modalService: ModalService,
    private router: Router,
    private handleError: ErrorhandlingService,
    public loaderService: LoaderService,
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(MAT_DIALOG_DATA)
    public data: { email: string; isGoogleLogin: boolean } // Inject dialog data
  ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
  }
  isBrowser: boolean;
  ngOnInit() {
    if (this.data?.email) {
      this.email = this.data.email;
    }
    this.startTimer();
  }

  startTimer() {
    const interval = setInterval(() => {
      if (this.timer > 0) {
        this.timer--;
      } else {
        clearInterval(interval);
      }
    }, 1000);
  }

  onDigitInput(event: any, index: number) {
    const input = event.target;
    let value = input.value;

    // Strictly enforce numeric only by replacing any non-digits
    if (/\D/g.test(value)) {
      value = value.replace(/\D/g, '');
      input.value = value;
    }

    this.verificationCode[index] = value;

    if (value && index < 5) {
      const nextInput = input.nextElementSibling as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    const numericData = pastedData.replace(/\D/g, '').slice(0, 6);

    for (let i = 0; i < numericData.length; i++) {
      if (i < 6) {
        this.verificationCode[i] = numericData[i];
      }
    }

    // Move focus to the last filled or next empty input
    const inputs = document.querySelectorAll('.digit-input');
    const lastIndex = numericData.length > 0 ? numericData.length - 1 : 0;
    const focusIndex = numericData.length < 6 ? numericData.length : 5;
    if (inputs[focusIndex]) {
      (inputs[focusIndex] as HTMLInputElement).focus();
    }
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const key = event.key;

    // Allow control keys (Backspace, Tab, Delete, Arrow keys, etc.)
    const controlKeys = [
      'Backspace',
      'Tab',
      'End',
      'Home',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
    ];

    // Allow paste shortcuts (Ctrl+V, Cmd+V)
    if (event.ctrlKey || event.metaKey) {
      return;
    }

    if (controlKeys.includes(key)) {
      if (key === 'Backspace' && !this.verificationCode[index] && index > 0) {
        const prevInput = (event.target as HTMLInputElement)
          .previousElementSibling as HTMLInputElement;
        if (prevInput) {
          prevInput.focus();
        }
      }
      return;
    }

    // Block non-numeric characters
    if (!/^\d$/.test(key)) {
      event.preventDefault();
      return;
    }

    // If a digit is pressed and the current box already has a value,
    // clear it so the new digit can take its place
    if (this.verificationCode[index]) {
      this.verificationCode[index] = '';
    }
  }

  verifyCode() {
    const code = this.verificationCode.join('');
    if (code.length < 6) {
      this.toaster.warning('Please enter the full 6-digit code.', 'Warning');
      return;
    }
    const payload = {
      email: this.email,
      otp: code,
    };
    this.loaderService.show();
    this.apiCallService
      .PostCallWithoutToken(payload, `User/UserVerify`)
      .subscribe(
        (response) => {
          if (response?.responseCode === 200) {
            this.loaderService.hide();
            this.fireLeadPixel(); 
            this.toaster.success(response?.responseMessage, 'Success');
            this.dialogRef.close();
            this.showotpVerifyMessage();
            // this.router.navigate(['/login']);
          } else {
            this.loaderService.hide();
            this.handleError.handleResponseError(response);
          }
        },
        (error) => {
          this.loaderService.hide();
          this.handleError.handleHttpError(error);
        }
      );
  }

  resendEmail() {
    if (!this.email) {
      this.toaster.error('Email address is not available!');
      return;
    }
    this.loaderService.show();

    this.apiCallService
      .GetCallWithoutToken(`User/ResendVerificationMail?email=${this.email}`)
      .subscribe(
        (response) => {
          if (response?.responseCode === 200) {
            this.loaderService.hide();
            this.toaster.success(
              'Verification email has been resent successfully!',
              'Success'
            );
          } else {
            this.loaderService.hide();
            this.handleError.handleResponseError(response);
          }
        },
        (error) => {
          this.loaderService.hide();
          this.handleError.handleHttpError(error);
        }
      );

    this.timer = 60; // Reset the timer after resending
    this.startTimer(); // Restart the timer
  }

  redirectToLogin() {
    this.dialogRef.close(); // Close the popup
    this.router.navigate(['/login']);
  }


    fireLeadPixel() {
    if (this.isBrowser  && typeof fbq === 'function') {
      fbq('track', 'Lead');
      console.log('Lead pixel fired');
    }
  }


    showotpVerifyMessage() {
    this.modalService.showPopup({
      title: 'Verification Successful!',
      message:
        'Your account is now verified. Congratulations',
      image: '/Images/welcome.png',
      buttonText: 'Login Now',
      // buttonText2: 'Later',
      path: '/login',
    });
  }
}
